import { useQuery } from '@tanstack/react-query';
import type { AgentApiCandidateProfileTagsIndex } from '@/types/serializers';

/**
 * 求職者タグ一覧を取得するフック
 */
export default function useCandidateTags() {
  return useQuery({
    queryKey: ['/agent/api/candidate_profile_tags'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_profile_tags', {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch candidate tags');
      }

      const data: AgentApiCandidateProfileTagsIndex = await response.json();
      return data;
    },
  });
}
